// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"116":"e65d2471","487":"9f7e9f5f"}[chunkId] + ".js";
};